import styled from "styled-components"
import media from "styled-media-query"

import BackgroundImage from "gatsby-background-image"

export const Wrapper = styled(BackgroundImage)`
  width: 100%;
  height: 387px;
  overflow: hidden;
  max-height: 387px;
  background-color: var(--backgroundHero);

  background-size: contain;
  background-position: 75% 100%;
  background-repeat: no-repeat;

  ${media.lessThan("medium")`
    height: 438px;
    max-height: 438px;
  `}

  ${media.lessThan("420px")`
    height: 464px;
    max-height: 464px;
  `}
`

export const Content = styled.div`
  max-width: 1190px;
  height: 100%;
  margin: 0 auto;
  display: flex;

  ${media.greaterThan("medium")`
    padding: 40px 50px 80px;
  `}

  ${media.greaterThan("large")`
    padding: 40px 50px 80px;
  `}

  ${media.lessThan("medium")`
    flex-direction: column;
    padding: 40px 30px 80px 30px;
  `}

  ${media.lessThan("520px")`
    flex-direction: column;
    padding: 40px 14px 80px 14px;
  `}
`

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const Text = styled.div`
  ${media.lessThan("large")`
    padding-left: 10px;
  `}

  ${media.lessThan("medium")`
    padding-top: 0;
    padding: 0 10px;
  `}

  ${media.lessThan("medium")`
  `}
`

export const Welcome = styled.span`
  font-size: 18px;
  line-height: 29px;
  color: var(--greyToBlack);
  margin-bottom: 18px;

  ${media.lessThan("large")`
    font-size: 18px;
  `}

  ${media.lessThan("medium")`
    font-size: 16px;
    margin-bottom: 8px;
  `}
`

export const CallToAction = styled.a`
  width: 240px;
  height: 40px;
  border: 2px solid var(--highlight);
  border-radius: 3px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.6s ease;

  &:hover {
    background: #67f3aa;
    color: #FFFFFF;
  }

  font-size: 20px;
  color: var(--highlight);

  ${media.greaterThan("medium")`
    font-size: 18px;
    width: 215px;
    height: 40px;
  `}

  ${media.lessThan("medium")`
    width: 150px;
    padding: 10px auto;
    font-size: 18px;
    align-self: flex-end;
  `}

  ${media.lessThan("520px")`
    width: 160px;
    height: 40px;
    margin-left: 10px;
    padding: 8px auto;
  `}

  ${media.lessThan("420px")`
    transform: translateY(30px);
    transition: none;
  `}
`

export const Title = styled.h1`
  font-weight: 500;
  line-height: 55px;
  display: flex;
  align-items: center;
  color: var(--titleHomeColor);
  width: 587px;

  ${media.greaterThan("medium")`
    max-width: 95%;
    font-size: 32px;
  `}

  ${media.greaterThan("large")`
    margin-top: 12px;
  `}

  ${media.lessThan("medium")`
    font-size: 32px;
    line-height: 50px;
  `}

  ${media.lessThan("520px")`
    width: 100%;
    font-size: 26px;
    flex-direction: column;
    align-items: flex-start;
    line-height: 40px;
    margin-top: 8px;
  `}
`

export const Animation = styled.span`
  color: var(--highlight);
  width: auto;
  display: flex;
  font-weight: 400;
  padding: 0 12px;
  justify-content: center;
  height: auto;

  ${media.lessThan("520px")`
    padding: 0;
  `}
`

export const Subtitle = styled(Title)`
font-weight: 500;
line-height: 60px;
color: var(--titleHomeColor);
width: 587px;

${media.greaterThan("medium")`
  max-width: 95%;
  font-size: 32px;
`}

  ${media.greaterThan("large")`
    margin-top: 0px;
    line-height: 50px;
  `}

${media.lessThan("medium")`
  font-size: 32px;
  line-height: 50px;
`}

${media.lessThan("520px")`
  width: 100%;
  font-size: 26px;
  line-height: 40px;
  margin-top: 0px;
`}
`
